import styled from 'styled-components';
import { spacing } from 'syf-component-library/defaultTheme';
export const ItemContainer = styled.li `
  margin: ${spacing.medium}px 0;
  &:first-child {
    margin-top: 0;
  }
`;
export const PaymentSecurityInfoContainer = styled.ul `
  padding: 0;
  margin: 0;
  list-style-position: inside;
`;
export const SubItemsContainer = styled.ul `
  list-style: disc;
`;
